module.exports = __webpack_public_path__ + "img/heatex-E-idle.f82e263e.png";